import { useTranslation } from "react-i18next"
import "../styles/EventsList.css"
import Container from "react-bootstrap/esm/Container"
import { useEffect, useState } from "react"
import eventService from "../services/eventService"
import BreikkiAlert from "./BreikkiAlert"
import LoadingAnimation from "./LoadingAnimation"
import windowUtils from "../utils/windowUtils"

/**
 * Article summary for front page. Contains a summary text and link to article.
 */
const EventsList = () => {

    const { t } = useTranslation()

    // obj keys are years, {2025: [...events], 2024: ...}
    const [eventsByYear, setEventsByYear] = useState({})
    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(null)


    const fetchEvents = () => {
        setLoading(true)
        setError(false)
        eventService.getAllEvents().then((allEvents) => {
            console.log({ allEvents })
            populateEventsByYear(allEvents)
            setLoading(false)
        }
        ).catch(err => {
            console.error(err)
            setError(true)
            setLoading(false)
        })
    }

    useEffect(fetchEvents, [])

    const getOrganizedOnDateStr = (organizedOn) => {
        const d = new Date(organizedOn)
        return `${d.getDate()}.${d.getMonth() + 1}`
    }

    const getOrganizedOnYear = (organizedOn) => {
        const d = new Date(organizedOn)
        return d.getFullYear();
    }

    const populateEventsByYear = (events) => {
        const byYear = {}

        for (const e of events) {
            const year = getOrganizedOnYear(e.organizedOn)
            if (!byYear[year]) {
                byYear[year] = []
            }
            byYear[year].push(e)
        }

        // sort each year’s events by date ascending
        for (const year in byYear) {
            byYear[year].sort((a, b) => new Date(a.organizedOn) - new Date(b.organizedOn))
        }

        setEventsByYear(byYear)
    }

    return (
        <Container className="BREIKKI-events-list-container">
            <span className="BREIKKI-events-list-title">
                {t("events_list_title")}
            </span>

            {loading &&
                <Container className="BREIKKI-article-page-loading-container" >
                    <LoadingAnimation />
                </Container>
            }

            {error ?
                <BreikkiAlert isError={true} onRetry={() => windowUtils.reloadWindow()} message={t("events_list_fetch_error_generic")} />
                :
                Object.keys(eventsByYear)
                    .sort((a, b) => b - a) // descending (2025, 2024, 2023…)
                    .map((year, i) => {
                        const events = eventsByYear[year];
                        return (
                            <div
                                key={year}
                                className={`BREIKKI-events-year-group${i % 2 === 0 ? " BREIKKI-events-year-group-dark" : ""}`}
                            >
                                <h4 className="BREIKKI-events-list-year-title">{year}</h4>
                                {events
                                    .map(e => (
                                        <div key={e._id} className="BREIKKI-events-list-row">
                                            <span className="BREIKKI-events-list-date">
                                                {getOrganizedOnDateStr(e.organizedOn)}
                                            </span>
                                            <span className="BREIKKI-events-list-event-name">
                                                <a
                                                    className={`BREIKKI-events-list-event-name-link ${e.eventType !== "GAME_NIGHT" ? "BREIKKI-bold" : ""}`}
                                                    href={`/event/${e._id}`}
                                                >
                                                    {e.name}
                                                </a>
                                            </span>
                                        </div>
                                    ))}
                            </div>
                        );
                    })}
        </Container>
    );

}


export default EventsList